var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.904,
    height: 18.998,
    viewBox: "0 0 19.904 18.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rating_star",
    transform: "translate(-1254.215 -646.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M.267.426,4.143-4.083,7.071.426,8.89,1.3s1.329.009,2.61,0c.353-.039.761-.576.87.633C12.485,3.183,9.475,4.1,8.89,6.2c-.641,2.307.554,5.775.554,5.775S6.734,9.76,4.143,9.76s-5.774,2.69-5.774,2.69L-.6,6.2-4.08,1.928Z",
    transform: "translate(1260.119 652.913)",
    fill: "#ff9e30"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862",
    transform: "translate(1254.216 647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M19.874,19a.583.583,0,0,0-.471-.4l-6.17-.9-2.759-5.591a.583.583,0,0,0-1.046,0l-2.759,5.6-6.17.9a.583.583,0,0,0-.323,1L4.64,23.953,3.587,30.1a.583.583,0,0,0,.846.615l5.518-2.9,5.518,2.9a.583.583,0,0,0,.846-.615l-1.054-6.145L19.726,19.6a.583.583,0,0,0,.148-.6Zm-5.646,4.328a.583.583,0,0,0-.168.516l.906,5.283-4.744-2.494a.583.583,0,0,0-.543,0l-4.743,2.5.906-5.283a.583.583,0,0,0-.168-.516L1.836,19.59l5.3-.771a.583.583,0,0,0,.439-.319l2.372-4.806L12.323,18.5a.583.583,0,0,0,.439.319l5.3.771Z",
    transform: "translate(0 -11.794)",
    fill: "#ff9e30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating_star.e37f2861f0970fed9e9b8d4ebb8b5505.svg";
export { ForwardRef as ReactComponent };